import React, { Component } from "react";
import * as firebase from "firebase";
import * as paypal from "paypal-rest-sdk";
import { Link } from "react-router-dom";

class Login extends Component {
  state = {
    logado: false
  };

  componentDidMount() {
    this.email = "";
  }

  updateEmail = evt => {
    this.email = evt.target.value;
  };

  updatePassword = evt => {
    this.password = evt.target.value;
  };

  login = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then(value => {
        this.setState({ logado: true });
      })
      .catch(erro => this.loginErrorhandle(erro));
  };

  createPaymentAgreement = (req, res) => {
    var d = new Date(Date.now() + 1 * 60 * 1000);
    d.setSeconds(d.getSeconds() + 4);
    var isDate = d.toISOString();
    var isoDate = isDate.slice(0, 19) + "Z";

    var billingPlanAttributes = {
      description: "Clearly Next Subscription.",
      merchant_preferences: {
        auto_bill_amount: "yes",
        cancel_url: "https://www.grupopw.net/pagamento?state=cancel",
        initial_fail_amount_action: "continue",
        max_fail_attempts: "2",
        return_url: "https://www.grupopw.net/pagamento",
        setup_fee: {
          currency: "BRL",
          value: "49.99"
        }
      },
      name: "Testing1-Regular1",
      payment_definitions: [
        {
          amount: {
            currency: "BRL",
            value: "49.99"
          },
          cycles: "0",
          frequency: "MONTH",
          frequency_interval: "1",
          name: "Regular 1",
          type: "REGULAR"
        }
      ],
      type: "INFINITE"
    };

    var billingPlanUpdateAttributes = [
      {
        op: "replace",
        path: "/",
        value: {
          state: "ACTIVE"
        }
      }
    ];

    var billingAgreementAttributes = {
      name: "Fast Speed Agreement",
      description: "Agreement for Fast Speed Plan",
      start_date: isoDate,
      plan: {
        id: "P-0NJ10521L3680291SOAQIVTQ"
      },
      payer: {
        payment_method: "paypal"
      },
      shipping_address: {
        line1: "StayBr111idge Suites",
        line2: "Cro12ok Street",
        city: "San Jose",
        state: "CA",
        postal_code: "95112",
        country_code: "US"
      }
    };

    // Create the billing plan
    paypal.billingPlan.create(billingPlanAttributes, function(
      error,
      billingPlan
    ) {
      if (error) {
        console.log(error);
        throw error;
      } else {
        console.log("Create Billing Plan Response");
        console.log(billingPlan);

        // Activate the plan by changing status to Active
        paypal.billingPlan.update(
          billingPlan.id,
          billingPlanUpdateAttributes,
          function(error, response) {
            if (error) {
              console.log(error);
              throw error;
            } else {
              console.log("Billing Plan state changed to " + billingPlan.state);
              billingAgreementAttributes.plan.id = billingPlan.id;

              // Use activated billing plan to create agreement
              paypal.billingAgreement.create(
                billingAgreementAttributes,
                function(error, billingAgreement) {
                  if (error) {
                    console.log(error);
                    throw error;
                  } else {
                    //console.log("Create Billing Agreement Response");
                    //console.log(billingAgreement);
                    for (
                      var index = 0;
                      index < billingAgreement.links.length;
                      index++
                    ) {
                      if (
                        billingAgreement.links[index].rel === "approval_url"
                      ) {
                        var approval_url = billingAgreement.links[index].href;
                        //console.log("For approving subscription via Paypal, first redirect user to");
                        //console.log(approval_url);

                        //res.redirect(approval_url);
                        window.location.replace(approval_url);

                        //console.log("Payment token is");
                        //console.log(url.parse(approval_url, true).query.token);
                        // See billing_agreements/execute.js to see example for executing agreement
                        // after you have payment token
                      }
                    }
                  }
                }
              );
            }
          }
        );
      }
    });
  };

  pagar = () => {
    this.createPaymentAgreement();
  };

  loginErrorhandle(erro) {
    this.setState({ isLoading: false });
    switch (erro.code) {
      case "auth/invalid-email":
        alert("Este email não é válido");
        break;
      case "auth/user-disabled":
        alert("Esse usuário foi bloqueado");
        break;
      case "auth/user-not-found":
        alert("Email ou senha inválidos");
        break;
      case "auth/wrong-password":
        alert("Email ou senha inválidos");
        break;
      default:
        console.log(erro);
        alert("Informe os dados corretamente");
        break;
    }
  }

  renderAcaunt() {
    if (this.state.logado === false) {
      return (
        <div className="container">
          <form method="POST">         
            <br />
            <div className="row">             
              <div className="col-md-1">
                <Link to="registro" type="button" className="btn btn-primary">
                  Criar conta
                </Link>
              </div>
            </div>
          </form>
        </div>
      );
    }
    return (
      <div className="container">
        <h1>Bem vindo</h1>        
      </div>
    );
  }

  /** 
   *    email:
            <br />
            <input
              type="email"
              name="email"
              className="form-control"
              onChange={this.updateEmail}
            />
            senha:
            <br />
            <input
              type="password"
              name="senha"
              className="form-control"
              onChange={this.updatePassword}
            />
   * 
   *  <div className="col-md-1">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.login}
                >
                  Entrar
                </button>
              </div>
   * 
   * <button type="button" className="btn btn-primary" onClick={this.pagar}>
          Pagar
        </button>
  */

  render() {
    return this.renderAcaunt();
  }
}

export default Login;
